module.exports = __webpack_public_path__ + "static/img/04994850.f513a159.png";